import { render, staticRenderFns } from "./RoomCBTDetail.vue?vue&type=template&id=c8fde6a6&scoped=true&"
import script from "./RoomCBTDetail.vue?vue&type=script&lang=js&"
export * from "./RoomCBTDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoomCBTDetail.vue?vue&type=style&index=0&id=c8fde6a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8fde6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8fde6a6')) {
      api.createRecord('c8fde6a6', component.options)
    } else {
      api.reload('c8fde6a6', component.options)
    }
    module.hot.accept("./RoomCBTDetail.vue?vue&type=template&id=c8fde6a6&scoped=true&", function () {
      api.rerender('c8fde6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTDetail.vue"
export default component.exports